import { Container, Text, Button } from '@chakra-ui/react';
import React from 'react'
import { useLocation } from 'react-router-dom';
import { useOrders } from '../../providers/OrderProvider';

export default function CancelConfirm() {

    const { state } = useLocation();

    const { cancelOrder } = useOrders();

    return (
        <div>
            <Container maxW='6xl' my='8' display='flex' flexDir='column' gap='4' alignItems='center' justifyContent='center' height='70vh' border='1px solid #b00000' borderRadius='md'>
                <Text as='h1' fontSize='2xl' fontWeight='bold'>Are you sure you want to cancel this order?</Text>
                <Text>Upon successful cancellation a refund of Rs {state.total} will be initiated.</Text>
                <Button onClick={() => cancelOrder(state.id) } colorScheme='red'>YES, CANCEL ORDER</Button>
            </Container>
        </div>
    )
}
